import React from 'react';
import { Info } from 'lucide-react';
import { Card } from './ui/card';

const galleryImages = [
  {
    url: 'https://images.unsplash.com/photo-1609280069904-ab36feb3f20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYXRocm9vbSUyMHRpbGV8ZW58MHx8fHwxNzY4MjE0NDc3fDA&ixlib=rb-4.1.0&q=85',
    title: 'Salle de bain moderne',
    description: 'Carrelage grand format avec douche à l\'italienne'
  },
  {
    url: 'https://images.unsplash.com/photo-1682888818696-906287d759f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiYXRocm9vbSUyMHRpbGV8ZW58MHx8fHwxNzY4MjE0NDc3fDA&ixlib=rb-4.1.0&q=85',
    title: 'Carrelage de luxe',
    description: 'Finitions haut de gamme avec mosaïque'
  },
  {
    url: 'https://images.unsplash.com/photo-1767022062386-36d4af393776?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHx0ZXJyYWNlJTIwdGlsZXN8ZW58MHx8fHwxNzY4MjE0NDg5fDA&ixlib=rb-4.1.0&q=85',
    title: 'Terrasse extérieure',
    description: 'Pierre naturelle résistante aux intempéries'
  },
  {
    url: 'https://images.unsplash.com/photo-1719324923613-ff0884b031ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHx0ZXJyYWNlJTIwdGlsZXN8ZW58MHx8fHwxNzY4MjE0NDg5fDA&ixlib=rb-4.1.0&q=85',
    title: 'Terrasse moderne',
    description: 'Carrelage antidérapant pour extérieur'
  },
  {
    url: 'https://images.unsplash.com/photo-1599799394212-71860043b6d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwzfHx0aWxlJTIwZmxvb3Jpbmd8ZW58MHx8fHwxNzY4MjE0NDczfDA&ixlib=rb-4.1.0&q=85',
    title: 'Carrelage en chevron',
    description: 'Pose en motif chevron pour un rendu élégant'
  },
  {
    url: 'https://images.unsplash.com/photo-1754552296820-22c693cb1f91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxjcmFmdHNtYW4lMjBpbnN0YWxsaW5nJTIwdGlsZXN8ZW58MHx8fHwxNzY4MjE0NDgzfDA&ixlib=rb-4.1.0&q=85',
    title: 'Travail de mosaïque',
    description: 'Détails et finitions soignées'
  }
];

const Gallery = () => {
  return (
    <section id="gallery" className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Galerie – <span className="text-blue-600">Exemples de finitions</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-6">
            Découvrez les types de finitions et de poses que nous réalisons 
            pour tous vos projets de carrelage
          </p>
          
          {/* Honest Disclaimer */}
          <div className="max-w-3xl mx-auto bg-blue-50 border-2 border-blue-200 rounded-xl p-6">
            <div className="flex items-start gap-3">
              <Info className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
              <div className="text-left">
                <p className="text-gray-700 leading-relaxed">
                  <strong className="text-gray-900">Photos illustratives</strong> des types de finitions que nous réalisons. 
                  Ces images représentent le style et la qualité de notre travail. 
                  <strong className="text-gray-900"> Des photos de nos réalisations réelles seront ajoutées progressivement.</strong>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {galleryImages.map((image, index) => (
            <Card 
              key={index}
              className="group overflow-hidden border-gray-200 hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/70 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="text-xl font-bold mb-1">{image.title}</h3>
                  <p className="text-sm text-gray-200">{image.description}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Bottom CTA - REMOVED - Site statique */}
        <div className="text-center mt-16">
          <div className="bg-white rounded-2xl shadow-xl p-8 max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-3">
              Un projet en tête ?
            </h3>
            <p className="text-gray-600">
              Contactez-nous directement par téléphone ou email pour discuter de votre projet
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
